import http from "@/utils/request"

export default {
	account: {
		list: async function (data = {}) {
			return await http.get("account/list", data);
		},
		add: async function (data = {}) {
			return await http.post("account/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("account/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("account/del", data);
		},
	},
	menu: {
		list: async function (data = {}) {
			return await http.get("menu/list", data);
		},
		add: async function (data = {}) {
			return await http.post("menu/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("menu/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("menu/del", data);
		},
		option: async function (data = {}) {
			return await http.get("menu/option", data);
		},
		quick: async function (data = {}) {
			return await http.post("menu/quick", data);
		},
	},
	dept: {
		list: async function (data = {}) {
			return await http.get("dept/list", data);
		},
		add: async function (data = {}) {
			return await http.post("dept/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("dept/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("dept/del", data);
		},
		option: async function (data = {}) {
			return await http.get("dept/option", data);
		},
	},
	role: {
		list: async function (data = {}) {
			return await http.get("role/list", data);
		},
		add: async function (data = {}) {
			return await http.post("role/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("role/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("role/del", data);
		},
		option: async function (data = {}) {
			return await http.get("role/option", data);
		},
	},
	post: {
		list: async function (data = {}) {
			return await http.get("post/list", data);
		},
		add: async function (data = {}) {
			return await http.post("post/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("post/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("post/del", data);
		},
		option: async function (data = {}) {
			return await http.get("post/option", data);
		},
	},
	upload: async function (data = {}, config = {}) {
		return await http.post("upload", data, config);
	},
	category: {
		list: async function (data = {}, config = {}) {
			return await http.get("file/category/list", data, config);
		},
		add: async function (data = {}, config = {}) {
			return await http.post("file/category/add", data, config);
		},
		edit: async function (data = {}, config = {}) {
			return await http.put("file/category/edit", data, config);
		},
		del: async function (data = {}, config = {}) {
			return await http.delete("file/category/del", data, config);
		}
	},
	file: {
		list: async function (data = {}, config = {}) {
			return await http.get("file/list", data, config);
		},
		upload: async function (data = {}, config = {}) {
			return await http.post("file/upload", data, config);
		},
		del: async function (data = {}, config = {}) {
			return await http.delete("file/del", data, config);
		},
		move: async function (data = {}, config = {}) {
			return await http.get("file/move", data, config);
		},
		save: async function (data = {}, config = {}) {
			return await http.post("file/save", data, config);
		},
	},
	region: {
		option: async function (data = {}) {
			return await http.get("region/option", data);
		}
	},
	config: {
		get: async function (data = {}) {
			return await http.get("config/get", data);
		},
		save: async function (data = {}) {
			return await http.post("config/save", data);
		},
		service: async function (data = {}) {
			return await http.get("config/service/get", data);
		},
		agreement: async function (data = {}) {
			return await http.get("config/agreement/get", data);
		},
	},
	banner: {
		list: async function (data = {}) {
			return await http.get("banner/list", data);
		},
		add: async function (data = {}) {
			return await http.post("banner/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("banner/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("banner/del", data);
		}
	},
}
